<template lang="pug"></template>

<script>
export default {
    name: 'BotaoDiagnosticoSocioAmbiental',
    componentOptions: {
        title: 'DiagnosticosSocioambientais',
        actions: [
            [
                {
                    name: 'Diagnóstico Socioambiental',
                    iconClass: 'lyra-icon lyra-grafico',
                    showView: false,
                    action: 'abrirDiagnosticosSocioambientais',
                    route: 'DiagnosticosSocioambientais',
                    nameTranslationKey:
                        'mensagens.menuLateral.diagnosticoSocioambiental'
                }
            ]
        ]
    },

    methods: {
        abrirDiagnosticosSocioambientais() {
            if (this.$route.name !== 'DiagnosticosSocioambientais') {
                this.$router.push({ name: 'DiagnosticosSocioambientais' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
